import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Rocket, ArrowRight } from "lucide-react";

/** Dashboard banner shown to admins/buyers until the start-up checklist is complete. */
export function OnboardingBanner() {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/onboarding/status").then((r) => setSt(r.data)).catch(() => setSt(null)); }, []);
  if (!st || st.progress >= 100) return null;
  const next = st.steps.find((s) => !s.done);
  return (
    <Link to="/onboarding" className="block border border-primary/40 bg-primary/5 p-3 mb-5 hover:bg-primary/10 transition-colors" data-testid="onboarding-banner">
      <div className="flex items-center gap-3 flex-wrap">
        <Rocket size={16} className="text-primary" />
        <div className="text-xs"><span className="font-black">Puesta en marcha {st.progress}%</span> · {st.done}/{st.total} pasos listos{next && <> · Siguiente: <b>{next.title}</b></>}</div>
        <div className="flex-1 min-w-[120px] h-2 bg-muted"><div className="h-2 bg-primary" style={{ width: `${st.progress}%` }} /></div>
        <span className="text-[11px] font-bold text-primary inline-flex items-center gap-1">Ver lista <ArrowRight size={11} /></span>
      </div>
    </Link>
  );
}
